import { _persianDigit } from './persianDigit';

export const _cardNumberFormatter = (number: string) => {
    // Convert the number to a string and split it into groups of 4 digits
    const numString = number.toString();
    const groups = [];

    // Loop through the string in chunks of 4
    for (let i = 0; i < numString.length; i += 4) {
        groups.push(numString.slice(i, i + 4));
    }

    // Join the groups with a hyphen and convert to Persian digits
    return _persianDigit(groups.join('-'));
};
